import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineMax, TweenLite, TweenMax} from "gsap";
import {TractorBeamLayerConfig} from "../../../config/TractorBeamLayerConfig";
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomWiggle.js");

export class UFOView extends BaseView {

    private _ufoTls:TimelineSprite;
    private _layer:PIXI.Container;


    private _leftThruster:TimelineSprite;
    private _rightThruster:TimelineSprite;

    private _ufoYPos:number = -15;
    private _ufoYPosPortrait:number = 84;

    private _isPortrait:boolean = false;

    constructor() {
        super(ResourcesGroupName.MAIN);

        this._layer = StageManager.getLayer(TractorBeamLayerConfig.UFO.name);
        this._layer.addChild(this);
    }

    initAnimations():void {
        this._ufoTls = this.createUFO();

        this._ufoTls.show();
        this._ufoTls.playLoop();

        this._leftThruster = this.createThruster();
        this._leftThruster.hide();
        //this._leftThruster.hide();
        //this._leftThruster.playLoop();


        this._rightThruster = this.createThruster(true);
        this._rightThruster.hide();
        //this._rightThruster.playLoop();

        this._ufoTls.addChild(this._leftThruster);
        this._ufoTls.addChild(this._rightThruster);

        this.addChild(this._ufoTls);


        //this.intoFsAnimation();
    }

    onResize(data:IResizeData):void {
        if(data.orientation === Orientation.LANDSCAPE) {
            this._ufoTls.position.set(665, this._ufoYPos);
            this._isPortrait = false;
        } else {
            this._ufoTls.position.set(665, this._ufoYPosPortrait);
            this._isPortrait = true;
        }
    }

    public intoFsAnimation(reel?:PIXI.Sprite):Timeline {
        const tl:TimelineMax = new TimelineMax({});
        //const tlWig = new TimelineLite();

        //var amount = 10;
        CustomWiggle.create("Wiggle.easeInOut", {wiggles : 4, type : "easeOut"});
        if(reel) {
            //reel.pivot = new PIXI.Point(-15, 0);
        }
        tl.add(TweenLite.to(this._ufoTls, 0.1, {
            y : (!this._isPortrait) ? this._ufoYPos + 5 : this._ufoYPosPortrait + 5
        }));
        tl.add([
            () => this._leftThruster.show(),
            () => this._leftThruster.playLoop(),
            () => this._rightThruster.show(),
            () => this._rightThruster.playLoop(),
            TweenLite.to(this._ufoTls, 2, {rotation : this.normalizedRotation(100 * 2.5), ease : "Wiggle.easeInOut"}),
            (reel) ? TweenLite.to(reel, 2, {
                rotation : this.normalizedRotation(100 * 2.5),
                ease : "Wiggle.easeInOut"
            }) : () => {},
            TweenMax.to(this._ufoTls, 0.5, {x : "+=10", yoyo : true, repeat : 5}),
            (reel) ? TweenMax.to(reel, 0.5, {y : "+=10", yoyo : true, repeat : 5}) : () => {}
        ]);
        tl.add([
            () => this._leftThruster.hide(),
            () => this._leftThruster.stopLoop(),
            () => this._rightThruster.hide(),
            () => this._rightThruster.stopLoop(),
            () => TweenLite.to(this._ufoTls, 0.1, {
                y : (!this._isPortrait) ? this._ufoYPos : this._ufoYPosPortrait
            })
        ]);
        /*var tl = new TimelineLite();
        tl.to(obj, duration, {rotation:30, ease:"Wiggle.easeOut"})
            .to( obj, duration, {x:100, ease:"Wiggle.easeOut"}, 0);*/

        return tl;
    }

    public normalizedRotation(r:number) {
        return (Math.PI * 2) / r;
    }

    protected createUFO():TimelineSprite {
        const ufo = new TimelineSprite(GameResources.getTextures("ufo"));
        ufo.anchor.set(0.5, 0.5);
        ufo.scale.set(1.65, 1.65);

        return ufo;
    }

    protected createThruster(right:boolean = false):TimelineSprite {
        const thrust:TimelineSprite = new TimelineSprite(GameResources.getTextures("ufoThruster"));
        thrust.anchor.set(0.5, 0.5);

        //thrust.scale.set(1.65, 1.65);

        if(right) {
            thrust.scale.set(-1, 1);
            thrust.position.set(340, 190);
        } else {
            thrust.position.set(-360, 190);
        }

        return thrust;
    }

}
